// All website content in one place for easy editing
const siteContent = {
  // Navbar
  navbar: {
    logo: 'Utilio',
    links: [
      { label: 'Home', path: '/' },
      { label: 'Team', path: '/team' },
      { label: 'Contact Us', path: '/contact' }
    ]
  },

  // Home page
  home: {
    // Hero section
    hero: {
      badge: '',
      headline: 'Next-Gen transcription for medical practitioners.',
      highlightedPhrase: 'Streamline your clinical day.',
      subheading: 'Utilio helps clinicians start informed, stay present during the consultation, and finish with structured notes tailored to their specialty and documentation style.',
      buttons: [
        { text: 'Book a Demo', variant: 'primary-home' },
      ]
    },

    // Care partner section
    carePartner: {
      heading: 'Your smart clinical assistant, built to reduce the noise',
      description: 'Reduce administrative burden and amplify clinical expertise. Our documentation tool integrates with your clinical workflow to streamline patient care.',
      bulletPoints: [
        'Patients share what matters → Utilio smartly summarizes → You start informed',
        'More than transcription. Intelligent, context-aware clinical documentation',
        'Clinically grounded documentation, right in your workflow'
      ]
    },

    // Device section
    deviceSection: {
      heading: 'Take Utilio wherever care happens.',
      subheading: 'Mobile or desktop. Seamlessly integrated into your existing workflows.',
      devices: [
        {
          icon: '📱',
          title: 'Mobile First',
          description: 'Access clinical intelligence on the go. Structured capture wherever you are for patient care.'
        },
        {
          icon: '🖥️',
          title: 'Web Extension',
          description: 'Deep review and synthesis capabilities. Your clinical digital companion.'
        }
      ]
    },

    // Impact section
    impact: {
      heading: 'Real world impact felt by clinicians',
      stats: [
        {
          number: '3+ Hours Saved',
          label: 'Spent In daily clinical documentation',
          link: "https://www.commonwealthfund.org/publications/surveys/2025/nov/causes-impacts-burnout-primary-care-physicians-10-countries",
          linkText: "View Survey Study",
          highlighted: false
        },
        {
          number: '74%',
          label: 'Clinicians report admin burden as top issue',
          link: "https://timesofindia.indiatimes.com/city/nagpur/faima-survey-flags-deep-gaps-in-medical-education-mental-health-of-medicos/articleshow/124613479.cms",
          linkText: "Read More",
          highlighted: true
        },
        {
          number: '8 in 10',
          label: 'Clinical Records Lack Critical Medico-Legal Protection',
          link: "https://www.researchgate.net/publication/403804360_Medic-legal_Documentation_in_Hospitals_Impact_on_Forensic_Evaluation_and_Legal_Outcomes_in_the_Indian_context",
          linkText: "View Legal Impact",
          highlighted: false
        }
      ]
    },

    // Trust section
    trust: {
      heading: 'Your duty of care, built in.',
      description: 'Enterprise-grade security, privacy, and encryption end-to-health and healthcare compliance standards.',
      badges: [
        { icon: '🔒', label: 'DPDP Compliant', color: 'neutral' },
        { icon: '🛡️', label: 'HIPAA Self Compliant', color: 'neutral' },
        { icon: '🔐', label: 'End-to-End Encryption', color: 'neutral' },
        { icon: '📋', label: 'GDPR Ready', color: 'neutral' }
      ]
    },

    // Testimonial section
    testimonial: {
      quote: '"Utilio has completely transformed how I practice medicine. I actually look my patients in the eye now, knowing the AI is capturing every detail perfectly."',
      author: 'Dr. Sanjay Mehta, MD',
      title: 'Chief of Radiology, Artemis Hospitals'
    },

    // Final CTA section
    finalCta: {
      heading: 'Ready to reclaim your time?',
      description: 'Join hundreds of clinicians who have transformed their workflows with Utilio.',
      buttons: [
        { text: 'Get Started Now', variant: 'primary' },
        { text: 'Schedule Demo', variant: 'secondary' }
      ]
    }
  },

  // Team page
  team: {
    heading: 'Meet the Team',
    intro: 'We\'re a family, a science teacher and two sons in engineering and computer science, building something together. Combining our different perspectives to create something meaningful for the healthcare providers.',
    philosophy: {
      heading: 'Our Philosophy',
      title: 'We\'ve seen how easily care gets pulled away from the people its meant for',
      description: 'This started with a simple observation, care today is often interrupted by the systems around it. Clinicians carry the weight of documentation, fragmented information, and limited time with patients. Utilio is our way of easing that burden, so care can feel more focused, more complete, and more human.',
      badge: ''
    },
    members: [
      {
        name: 'Ritu Mehta',
        role: 'The One Who Guides the Way - CEO'
      },
      {
        name: 'Harshul Mehta',
        role: 'The One Who Makes It Work - CTO'
      },
      {
        name: 'Ratul Mehta',
        role: 'The One Who Brings It Together - COO'
      }
    ]
  },

  // Contact page
  contact: {
    label: 'CONNECT WITH US',
    heading: 'Moving towards',
    highlightedHeading: 'better care.',
    intro: 'We\'re here to help you understand how Utilio fits into your workflow. Reach out for a demo or to learn more.',
    form: {
      labels: {
        fullName: 'FULL NAME',
        email: 'EMAIL ADDRESS',
        inquiryType: 'INQUIRY TYPE',
        message: 'MESSAGE'
      },
      placeholders: {
        fullName: 'Rohit Verma',
        email: 'rohit@example.com',
        message: 'How can we help?'
      },
      inquiryOptions: [
        'Product Demo',
        'Partnership Inquiry',
        'General Question'
      ],
      submitButton: 'Connect With Us',
      successMessage: 'Thank you for reaching out! We\'ll be in touch soon.'
    },
    directChannels: {
      heading: 'Direct Channels',
      intro: 'Our specialized team is available for deep-dive technical demos and strategic clinical insights.',
      channels: [
        {
          icon: '✉️',
          label: 'EMAIL SUPPORT',
          title: 'utiliosolutions@gmail.com',
          details: '24h Response Time'
        },
        {
          icon: '🚀',
          label: 'DEMO INQUIRIES',
          title: '+1 (555) 234-8901',
          details: ''
        }
      ]
    }
  },

  // Footer
  footer: {
    brandName: 'Utilio',
    tagline: 'Powering clinical intelligence.',
    privacyLink: 'Privacy Policy',
    copyright: '© 2026 Utilio LLP. All rights reserved.'
  },

  // Privacy Policy page - Updated with DPDP Compliance
  privacyPolicy: {
    EN: {
      badge: 'PRIVACY & DATA PROTECTION',
      title: 'Privacy Policy & DPDP Compliance',
      contentsTitle: 'Contents',
      subtitle: 'Utilio operates as a Data Fiduciary under India’s Digital Personal Data Protection (DPDP) Act, 2023. We are committed to transparency in how we handle clinical data.',
      lastUpdated: 'Last updated: May 2026',
      contents: [
        { id: 'introduction', label: '1. Introduction & DPDP Compliance' },
        { id: 'information-collection', label: '2. Transcription & PII Disclosure' },
        { id: 'purpose-processing', label: '3. Data Isolation Guarantee' },
        { id: 'data-security', label: '4. Security & India Localization' },
        { id: 'data-retention', label: '5. Minimal Footprint Policy' },
        { id: 'user-responsibilities', label: '6. Clinician Responsibilities' },
        { id: 'clinical-disclaimer', label: '7. Limitation of Liability' },
        { id: 'data-sharing', label: '8. Data Sharing & Third-Party Disclosures' },
        { id: 'data-collection', label: '9. Browser-Level and Data Collection' },
        { id: 'chrome-permission', label: '10. Use of Chrome Permissions' },
        { id: 'user-rights', label: '11. Grievance Redressal' },
      ],
      sections: [
        {
          id: 'introduction',
          number: 1,
          title: 'Introduction & Digital Personal Data Protection (DPDP) Compliance',
          paragraphs: [
            'Utilio acts as a Data Fiduciary and Data Processor for healthcare documentation. This policy is designed in accordance with India’s Digital Personal Data Protection (DPDP) Act, 2023.',
            'By using Utilio, you (the Healthcare Provider) provide informed consent for the processing of digital personal data as described herein.'
          ]
        },
        {
          id: 'information-collection',
          number: 2,
          title: 'Information Collection: The Transcription Clause',
          paragraphs: [
            'During this MVP phase, we collect the following data types:',
            '• Audio Inputs: Recorded clinical encounters',
            '• Transcripts: Text generated from audio',
            '• AI Outputs: Clinical summaries and structured medical notes',
            'Important Disclosure (PII/GNID): Our automated filtering for Personally Identifiable Information (Names, Aadhaar, or GNIDs) is in a developmental beta phase. Identifiers spoken during a recording will be captured in the transcript. It is the User’s responsibility to review and redact sensitive identifiers before final storage.'
          ]
        },
        {
          id: 'purpose-processing',
          number: 3,
          title: 'Purpose of Processing & No-Training Guarantee',
          paragraphs: [
            'We process data solely to provide documentation assistance:',
            '• Clinical Productivity: Generating notes to reduce physician burnout',
            '• Data Isolation: Your patient data is NOT used to train our foundational Large Language Models (LLMs)',
            'We maintain strict data silos to ensure your practice data remains isolated and confidential.'
          ]
        },
        {
          id: 'data-security',
          number: 4,
          title: 'Data Security & Localization (India Region)',
          paragraphs: [
            'Data Residency: In compliance with Indian sovereignty, all data is stored on secure cloud infrastructure located within India.',
            'Encryption: Data is secured with AES-256 encryption at rest and SSL/TLS in transit. Access is limited to the authenticated Healthcare Provider.'
          ]
        },
        {
          id: 'data-retention',
          number: 5,
          title: 'Data Retention: Minimal Footprint Policy',
          paragraphs: [
            'To minimize risk during the MVP demo phase:',
            '• Audio Deletion: Raw audio is deleted immediately after the transcript is generated.',
            '• Transcript Retention: Summaries are retained only for a specified period or until manually deleted by the user.',
            '• User Control: You may trigger a "Hard Delete" of any session data at any time via the dashboard.'
          ]
        },
        {
          id: 'user-responsibilities',
          number: 6,
          title: 'User (Healthcare Provider) Responsibilities',
          paragraphs: [
            'As the primary Data Fiduciary, you agree to:',
            '1. Obtain Consent: Secure verbal or written consent from patients before recording.',
            '2. Verify Accuracy: Review all AI outputs. Utilio is an assistant; the clinician retains 100% legal responsibility for the record.',
            '3. Manual Redaction: Remove any sensitive IDs or names if they were not automatically filtered.'
          ]
        },
        {
          id: 'clinical-disclaimer',
          number: 7,
          title: 'Clinical Disclaimer & Limitation of Liability',
          paragraphs: [
            'Utilio is a documentation aid, not a medical device or a diagnostic tool.',
            '• We are not liable for clinical errors or AI hallucinations.',
            '• We are not liable for the exposure of PII that the User chose to record while knowing filtering is in beta.',
            'Final documentation accuracy remains the responsibility of the qualified professional.'
          ]
        },
        {
          id: 'data-sharing',
          number: 8,
          title: 'Data Sharing & Third-Party Disclosures',
          paragraphs: [
            'To fulfill our service functionality, Utilio shares specific data with the following categories of external service providers:',
            '• AI Processing Infrastructure: Transcripts and audio segments are transmitted via secure, encrypted APIs to enterprise AI infrastructure providers (such as Google Gemini and Sarvam AI) solely to generate clinical summaries. These third parties are contractually bound to process data strictly as service providers and are prohibited from using this data to train their models.',
            '• Cloud Infrastructure Hosting: All application data, authentication logs, and data processing nodes are hosted on secure infrastructure provided by Supabase, restricted entirely to regions within India.',
            '• Legal and Regulatory Compliance: We do not sell, lease, or monetize your data. Data is only shared with third parties under your direct instructions, as outlined above, or if required to comply with statutory legal mandates under applicable Indian law.']
        },
        {
          id: 'data-collection',
          number: 9,
          title: 'Browser-Level & User Agency Data Collection',
          paragraphs: [
            'In addition to the clinical inputs explicitly recorded by the user, the Utilio Chrome Extension collects technical metadata required to maintain stability, security, and authentication state:',
            '• Authentication States: Tokens are securely handled and stored within the user’s local browser environment to keep the user session logged in safely.',
            '• Technical Metadata: Basic telemetry including extension software version, browser type, and operating system configuration is collected to troubleshoot compatibility errors and provide software updates.']
        },
        {
          id: 'chrome-permission',
          number: 10,
          title: 'Use of Chrome Permissions',
          paragraphs: [
            'In accordance with the Chrome Web Store Least Privilege policy, the Utilio extension requests only the minimum necessary system permissions:',
            '• Microphone (audio permission): Used exclusively to capture clinical speech fragments when the user intentionally clicks the "Record" interface button. No background monitoring or passive listening occurs.',
            '• Storage (storage permission): Used to cache local app layout preferences, theme selections, and temporary session tokens within the local browser environment.']
        },
        {
          id: 'user-rights',
          number: 11,
          title: 'Your Rights & Grievance Redressal',
          paragraphs: [
            'In accordance with the DPDP Act 2023, you and your patients possess the right to access, correct, and erase personal data, as well as the right to withdraw consent at any time.',
            'For any privacy-related queries or to exercise these rights, please contact our designated Grievance Officer: Ratul Mehta (Co-Founder) at utiliosolutions@gmail.com.',
            'We will acknowledge grievances within 48 hours and provide a resolution within 30 days. You also maintain the right to lodge a complaint with the Data Protection Board of India if you believe your rights have been violated.'
          ]
        }
      ]
    },
    HI: {
      badge: 'गोपनीयता और डेटा सुरक्षा',
      title: 'गोपनीयता नीति और डीपीडीपी अनुपालन',
      contentsTitle: 'विषय सूची',
      subtitle: 'यूटिलियो भारत के डिजिटल व्यक्तिगत डेटा संरक्षण (डीपीडीपी) अधिनियम, 2023 के तहत एक डेटा फिडुशियरी के रूप में संचालित होता है। हम नैदानिक डेटा को संभालने के तरीके में पारदर्शिता के लिए प्रतिबद्ध हैं।',
      lastUpdated: 'अंतिम अपडेट: मई 2026',
      contents: [
        { id: 'introduction', label: '1. परिचय और डीपीडीपी अनुपालन' },
        { id: 'information-collection', label: '2. ट्रांसक्रिप्शन और पीआईआई प्रकटीकरण' },
        { id: 'purpose-processing', label: '3. डेटा अलगाव की गारंटी' },
        { id: 'data-security', label: '4. सुरक्षा और भारत स्थानीयकरण' },
        { id: 'data-retention', label: '5. न्यूनतम पदचिह्न नीति' },
        { id: 'user-responsibilities', label: '6. चिकित्सक की जिम्मेदारियां' },
        { id: 'clinical-disclaimer', label: '7. देयता की सीमा' },
        { id: 'data-sharing', label: '8. डेटा साझाकरण और तृतीय-पक्ष प्रकटीकरण' },
        { id: 'data-collection', label: '9. ब्राउज़र-स्तर और डेटा संग्रह' },
        { id: 'chrome-permission', label: '10. क्रोम अनुमतियों का उपयोग' },
        { id: 'user-rights', label: '11. आपकी अधिकार और शिकायत निवारण' },
      ],
      sections: [
        {
          id: 'introduction',
          number: 1,
          title: 'परिचय और डिजिटल व्यक्तिगत डेटा संरक्षण (डीपीडीपी) अनुपालन',
          paragraphs: [
            'यूटिलियो स्वास्थ्य सेवा प्रलेखन के लिए डेटा फिडुशियरी और डेटा प्रोसेसर के रूप में कार्य करता है। यह नीति भारत के डिजिटल व्यक्तिगत डेटा संरक्षण (डीपीडीपी) अधिनियम, 2023 के अनुसार तैयार की गई है।',
            'यूटिलियो का उपयोग करके, आप (स्वास्थ्य सेवा प्रदाता) यहां वर्णित डिजिटल व्यक्तिगत डेटा के प्रसंस्करण के लिए सूचित सहमति प्रदान करते हैं।'
          ]
        },
        {
          id: 'information-collection',
          number: 2,
          title: 'सूचना संग्रह: ट्रांसक्रिप्शन क्लॉज',
          paragraphs: [
            'इस एमवीपी (MVP) चरण के दौरान, हम निम्नलिखित डेटा प्रकार एकत्र करते हैं:',
            '• ऑडियो इनपुट: रिकॉर्ड किए गए नैदानिक मुठभेड़',
            '• ट्रांसक्रिप्ट: टेक्स्ट उत्पन्न किया गया',
            '• एआई आउटपुट: नैदानिक सारांश और संरचित चिकित्सा नोट',
            'महत्वपूर्ण प्रकटीकरण (PII/GNID): व्यक्तिगत रूप से पहचान योग्य जानकारी (नाम, आधार, या GNID) के लिए हमारा स्वचालित फ़िल्टरिंग अभी विकास के चरण में है। रिकॉर्डिंग के दौरान बोले गए पहचानकर्ताओं को ट्रांसक्रिप्ट में कैप्चर किया जाएगा। अंतिम भंडारण से पहले संवेदनशील पहचानकर्ताओं की समीक्षा करना और उन्हें हटाना उपयोगकर्ता की जिम्मेदारी है।'
          ]
        },
        {
          id: 'purpose-processing',
          number: 3,
          title: 'प्रसंस्करण का उद्देश्य और नो-ट्रेनिंग गारंटी',
          paragraphs: [
            'हम केवल प्रलेखन सहायता प्रदान करने के लिए डेटा संसाधित करते हैं:',
            '• नैदानिक उत्पादकता: चिकित्सक के तनाव को कम करने के लिए नोट्स तैयार करना',
            '• डेटा अलगाव: आपके रोगी डेटा का उपयोग हमारे मूलभूत लार्ज लैंग्वेज मॉडल (LLMs) को प्रशिक्षित करने के लिए नहीं किया जाता है।',
            'हम यह सुनिश्चित करने के लिए सख्त डेटा आइसोलेशन बनाए रखते हैं कि आपके अभ्यास का डेटा गोपनीय रहे।'
          ]
        },
        {
          id: 'data-security',
          number: 4,
          title: 'डेटा सुरक्षा और स्थानीयकरण (भारत क्षेत्र)',
          paragraphs: [
            'डेटा निवास: भारतीय संप्रभुता के अनुपालन में, सभी डेटा भारत के भीतर स्थित सुरक्षित क्लाउड इंफ्रास्ट्रक्चर पर संग्रहीत किया जाता है।',
            'एन्क्रिप्शन: डेटा को AES-256 एन्क्रिप्शन और SSL/TLS के साथ सुरक्षित किया जाता है। पहुंच केवल प्रमाणित स्वास्थ्य सेवा प्रदाता तक ही सीमित है।'
          ]
        },
        {
          id: 'data-retention',
          number: 5,
          title: 'डेटा प्रतिधारण: न्यूनतम पदचिह्न नीति',
          paragraphs: [
            'एमवीपी डेमो चरण के दौरान जोखिम को कम करने के लिए:',
            '• ऑडियो विलोपन: ट्रांसक्रिप्ट जेनरेट होने के तुरंत बाद कच्चा ऑडियो हटा दिया जाता है।',
            '• ट्रांसक्रिप्ट प्रतिधारण: सारांश केवल एक निर्दिष्ट अवधि के लिए या उपयोगकर्ता द्वारा मैन्युअल रूप से हटाए जाने तक रखे जाते हैं।',
            '• उपयोगकर्ता नियंत्रण: आप डैशबोर्ड के माध्यम से किसी भी समय किसी भी सत्र डेटा को "हार्ड डिलीट" कर सकते हैं।'
          ]
        },
        {
          id: 'user-responsibilities',
          number: 6,
          title: 'उपयोगकर्ता (स्वास्थ्य सेवा प्रदाता) की जिम्मेदारियां',
          paragraphs: [
            'प्राथमिक डेटा फिडुशियरी के रूप में, आप सहमत हैं:',
            '1. सहमति प्राप्त करें: रिकॉर्डिंग से पहले रोगियों से मौखिक या लिखित सहमति सुरक्षित करें।',
            '2. सटीकता सत्यापित करें: सभी एआई आउटपुट की समीक्षा करें। यूटिलियो एक सहायक है; नैदानिक रिकॉर्ड के लिए 100% कानूनी जिम्मेदारी चिकित्सक की होती है।',
            '3. मैन्युअल संपादन: यदि संवेदनशील आईडी या नाम स्वचालित रूप से फ़िल्टर नहीं किए गए थे, तो उन्हें हटा दें।'
          ]
        },
        {
          id: 'clinical-disclaimer',
          number: 7,
          title: 'नैदानिक अस्वीकरण और देयता की सीमा',
          paragraphs: [
            'यूटिलियो एक प्रलेखन सहायता है, चिकित्सा उपकरण या नैदानिक उपकरण नहीं।',
            '• हम नैदानिक त्रुटियों या एआई मतिभ्रम (hallucinations) के लिए उत्तरदायी नहीं हैं।',
            '• हम उस PII के उजागर होने के लिए उत्तरदायी नहीं हैं जिसे उपयोगकर्ता ने फ़िल्टरिंग के बीटा में होने की जानकारी के बावजूद रिकॉर्ड करने का निर्णय लिया।',
            'अंतिम प्रलेखन सटीकता योग्य पेशेवर की जिम्मेदारी बनी रहती है।'
          ]
        },
        {
          id: 'data-sharing',
          number: 8,
          title: 'डेटा साझाकरण और तृतीय-पक्ष प्रकटीकरण',
          paragraphs: [
            'हमारी सेवा कार्यक्षमता को पूरा करने के लिए, यूटिलियो निम्नलिखित श्रेणियों के बाहरी सेवा प्रदाताओं के साथ विशिष्ट डेटा साझा करता है:',
            '• एआई प्रोसेसिंग इंफ्रास्ट्रक्चर: नैदानिक सारांश तैयार करने के लिए ट्रांसक्रिप्ट और ऑडियो सेगमेंट को सुरक्षित, एन्क्रिप्टेड एपीआई के माध्यम से उद्यम एआई प्रदाताओं (जैसे गूगल जेमिनी और सर्वम एआई) को प्रेषित किया जाता है। ये तृतीय पक्ष डेटा को कड़ाई से सेवा प्रदाताओं के रूप में संसाधित करने के लिए बाध्य हैं और उन्हें अपने मॉडल को प्रशिक्षित करने के लिए इस डेटा का उपयोग करने से प्रतिबंधित किया गया है।',
            '• क्लाउड इंफ्रास्ट्रक्चर होस्टिंग: सभी एप्लिकेशन डेटा, प्रमाणीकरण लॉग और डेटा प्रोसेसिंग नोड्स गूगल क्लाउड सर्विसेज (GCP) द्वारा प्रदान किए गए सुरक्षित बुनियादी ढांचे पर होस्ट किए जाते हैं, जो पूरी तरह से भारत के भीतर के क्षेत्रों तक सीमित हैं।',
            '• कानूनी और नियामक अनुपालन: हम आपका डेटा बेचते या मुद्रीकरण नहीं करते हैं। डेटा केवल आपके प्रत्यक्ष निर्देशों के तहत तृतीय पक्षों के साथ साझा किया जाता है, या यदि लागू भारतीय कानून के तहत वैधानिक कानूनी आदेशों का अनुपालन करने की आवश्यकता होती है।'
          ]
        },
        {
          id: 'data-collection',
          number: 9,
          title: 'ब्राउज़र-स्तर और डेटा संग्रह',
          paragraphs: [
            'उपयोगकर्ता द्वारा स्पष्ट रूप से रिकॉर्ड किए गए नैदानिक इनपुट के अलावा, यूटिलियो क्रोम एक्सटेंशन स्थिरता, सुरक्षा और प्रमाणीकरण स्थिति बनाए रखने के लिए आवश्यक तकनीकी मेटाडेटा एकत्र करता है:',
            '• प्रमाणीकरण स्थितियां: उपयोगकर्ता सत्र को सुरक्षित रूप से लॉग इन रखने के लिए टोकन को उपयोगकर्ता के स्थानीय ब्राउज़र वातावरण के भीतर सुरक्षित रूप से संग्रहीत किया जाता है।',
            '• तकनीकी मेटाडेटा: संगतता त्रुटियों के निवारण और सॉफ़्टवेयर अपडेट प्रदान करने के लिए एक्सटेंशन सॉफ़्टवेयर संस्करण, ब्राउज़र प्रकार और ऑपरेटिंग सिस्टम कॉन्फ़िगरेशन सहित बुनियादी टेलीमेट्री एकत्र की जाती है।'
          ]
        },
        {
          id: 'chrome-permission',
          number: 10,
          title: 'क्रोम अनुमतियों का उपयोग',
          paragraphs: [
            'क्रोम वेब स्टोर की न्यूनतम विशेषाधिकार नीति के अनुसार, यूटिलियो एक्सटेंशन केवल न्यूनतम आवश्यक सिस्टम अनुमतियों का अनुरोध करता है:',
            '• माइक्रोफ़ोन (ऑडियो अनुमति): जब उपयोगकर्ता जानबूझकर "रिकॉर्ड" इंटरफ़ेस बटन पर क्लिक करता है, तो विशेष रूप से नैदानिक भाषण के अंशों को कैप्चर करने के लिए उपयोग किया जाता है। कोई बैकग्राउंड मॉनिटरिंग या पैसिव लिसनिंग नहीं होती है।',
            '• स्टोरेज (स्टोरेज अनुमति): स्थानीय ब्राउज़र वातावरण के भीतर स्थानीय ऐप लेआउट प्राथमिकताओं, थीम चयन और अस्थायी सत्र टोकन को कैश करने के लिए उपयोग किया जाता है।'
          ]
        },
        {
          id: 'user-rights',
          number: 11,
          title: 'आपके अधिकार और शिकायत निवारण',
          paragraphs: [
            'डीपीडीपी अधिनियम 2023 के अनुसार, आपके और आपके रोगियों के पास व्यक्तिगत डेटा तक पहुँचने, उसे सुधारने और मिटाने के साथ-साथ किसी भी समय सहमति वापस लेने का अधिकार है।',
            'किसी भी गोपनीयता संबंधी पूछताछ के लिए या इन अधिकारों का उपयोग करने के लिए, कृपया हमारे नामित शिकायत अधिकारी से संपर्क करें: रातुल मेहता (सह-संस्थापक) utiliosolutions@gmail.com पर।',
            'हम 48 घंटों के भीतर शिकायतों को स्वीकार करेंगे और 30 दिनों के भीतर समाधान प्रदान करेंगे। यदि आपको लगता है कि आपके अधिकारों का उल्लंघन हुआ है, तो आपको भारतीय डेटा संरक्षण बोर्ड के पास शिकायत दर्ज करने का भी अधिकार है।'
          ]
        }
      ]
    }
  }
};

export default siteContent;